import { Col, Row } from "react-bootstrap";
import BreadCrumbs from "./BreadCrumbs";
import CertificateFields from "./CertificateFields";
import { useParams } from "react-router-dom";
import Page404 from "../../../../../pages/auth/Page404";

import useAppSelector from "../../../../../hooks/useAppSelector";
import useAppDispatch from "../../../../../hooks/useAppDispatch";
import { useState } from "react";

import Page500 from "../../../../../pages/auth/Page500";

import {
  ICertificateOfRegistrationDetails,
  ICertificateOfRegistrationDetailsResponse,
} from "../../../../../api/CircularEconomy/CertificateOfRegistration/ICertificateOfRegistration";
import { DocumentsGrid } from "./DocumentsGrid";
import {
  loadCertificateOfRegistrationAsync,
  selectCertificateOfRegistrationResponse,
} from "../../../redux/slices/certificateOfRegistration";
import Loading from "../../../../../leap-components/Loading";
import ContactUs from "./ContactUs";

const IsCertificateOfRegistrationReady = (
  notifierResponse?: ICertificateOfRegistrationDetailsResponse
) => {
  if (!notifierResponse) {
    return false;
  }

  if (notifierResponse.response.httpStatusCode === 404) {
    return false;
  }

  if (!notifierResponse.certificateOfRegistration) {
    return false;
  }

  return true;
};

const GetNotReadyComponent = (
  notifierResponse?: ICertificateOfRegistrationDetailsResponse
) => {
  if (!notifierResponse) {
    return <Loading />;
  }

  if (notifierResponse.response.httpStatusCode === 404) {
    return <Page404 />;
  }

  if (!notifierResponse.certificateOfRegistration) {
    return <Page500 />;
  }

  return <Loading />;
};

const CertificateOfRegistrationDetails = () => {
  const [loading, setLoading] = useState(false);
  const certificateOfRegistrationSelector = useAppSelector(
    selectCertificateOfRegistrationResponse
  );
  const dispatch = useAppDispatch();

  let { licenseId } = useParams();
  if (!licenseId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadCertificateOfRegistrationAsync(licenseId));
  }

  if (
    !IsCertificateOfRegistrationReady(
      certificateOfRegistrationSelector.certificateOfRegistrationResponse
    )
  ) {
    return GetNotReadyComponent(
      certificateOfRegistrationSelector.certificateOfRegistrationResponse
    );
  }

  const corDetails = certificateOfRegistrationSelector
    .certificateOfRegistrationResponse
    ?.certificateOfRegistration as ICertificateOfRegistrationDetails;

  const contentElement = (
    <div>
      <Row>
        <Col className="ps-0">
          <CertificateFields certificateOfRegistrationDetails={corDetails} />
        </Col>
      </Row>
      <Row>
        <Col className="ps-0">
          <DocumentsGrid licenseId={corDetails.licence_id} />
        </Col>
      </Row>
      <Row>
        <Col className="ps-0">
          <ContactUs />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs regno={corDetails.reg_no} />
      <div className="ps-0">{contentElement}</div>
    </div>
  );
};

export default CertificateOfRegistrationDetails;
